import { TrimbleMapsSingleSearchApi } from '@trukt/portal-utils/TrimbleMapsSingleSearchApi';

export const trimbleMapsSingleSearchApi = new TrimbleMapsSingleSearchApi(
  import.meta.env.VITE_TRIMBLE_MAPS_API_KEY,
);
